import axios from 'axios';
import { FC, useEffect, useState } from 'react';
import styled from 'styled-components';
import SuggestionAPI, { SuggestionItemType } from '../../../api/suggestion.api';
import { bugsnagNotify } from '../../../bugsnag';
import { useRootStoreContext } from '../../../stores/RootStore';
import { SuggestionItem } from '../../SuggestionItem';
import moment from 'moment-timezone';

const Style = styled.div`
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 8px;

    > button {
        min-width: 56px;
        margin-right: 8px;
        margin-bottom: 8px;
    }
`;

type Props = {
    restaurantId: number;
    restaurantSlug: string;
    isWaitingListWhenFullyBooked: boolean;
};

const suggestionApi = new SuggestionAPI();

const WaitingListTimes: FC<Props> = ({
    restaurantId,
    restaurantSlug,
    isWaitingListWhenFullyBooked,
}) => {
    const {
        SearchCriteriaStore: {
            reducer: [{ guests, dateTime }],
        },
    } = useRootStoreContext();
    const [allTimes, setAllTimes] = useState<SuggestionItemType[]>([]);

    useEffect(() => {
        const cancelToken = axios.CancelToken.source();

        suggestionApi
            .getAllWaitingListTimesByDate(
                restaurantId,
                moment(dateTime, moment.defaultFormatUtc).format(
                    'YYYY-MM-DDTHH:mm',
                ),
                guests,
                cancelToken,
            )
            .then((res) => {
                setAllTimes(
                    res.data.map((x) => ({
                        ...x,
                        date: moment(x.date, moment.defaultFormatUtc),
                    })),
                );
            })
            .catch((e) => {
                if (!axios.isCancel(e)) {
                    bugsnagNotify(e);
                }
            });

        return () => {
            cancelToken.cancel();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Style>
            {allTimes.map((x, i) => (
                <SuggestionItem
                    key={i}
                    data={x}
                    restaurantId={restaurantId}
                    restaurantSlug={restaurantSlug}
                    guests={guests}
                    isWaitingList={true}
                    isWaitingListWhenFullyBooked={isWaitingListWhenFullyBooked}
                />
            ))}
        </Style>
    );
};

export default WaitingListTimes;
